import PropTypes from 'prop-types';
import Select from 'react-select';
import { fetchBreedList } from 'services/API/API';
import { useState } from 'react';
import { useEffect } from 'react';

import React from 'react';
import {
  customStylesForBreed,
  customStylesForBreedLong,
} from './customStylesForBreed';

import { customStylesForGallery } from './customStylesForGallery';
import { customStylesForGalleryLong } from './customStylesForGallery';
import { useLocation } from 'react-router-dom';

const SelectBreeds = ({ onSelect, startListValue }) => {
  const [options, setOption] = useState([startListValue]);
  const [showOptions, setShowOptions] = useState([]);
  const [isLong, setIslong] = useState(false);
  const [placeholder, setPlaceHolder] = useState('');

  const { pathname } = useLocation();

  const handleSelect = ({ id }) => {
    if (id === 'more') {
      setShowOptions(options);
      setIslong(true);
    } else {
      onSelect(id);
      setIslong(false);

      const newOpt = options.slice(0, 7);
      newOpt.push({ name: 'more', label: '...', id: 'more' });
      setShowOptions(newOpt);
    }
  };

  useEffect(() => {
    pathname === '/breeds'
      ? setPlaceHolder('All breeds')
      : setPlaceHolder('None');
  }, [pathname]);

  useEffect(() => {
    fetchBreedList().then(data => {
      data.map(({ name, id }) =>
        setOption(prev => [...prev, { name, label: name, id }])
      );
    });
  }, []);

  useEffect(() => {
    const newOpt = options.slice(0, 7);
    newOpt.push({ name: 'more', label: '...', id: 'more' });
    setShowOptions(newOpt);
  }, [options]);

  return (
    <>
      {isLong ? (
        <Select
          options={showOptions}
          styles={
            pathname === '/breeds'
              ? customStylesForBreedLong
              : customStylesForGalleryLong
          }
          onChange={handleSelect}
          defaultValue={showOptions[0]}
        />
      ) : (
        <Select
          closeMenuOnSelect={false}
          options={showOptions}
          styles={
            pathname === '/breeds'
              ? customStylesForBreed
              : customStylesForGallery
          }
          onChange={handleSelect}
          defaultValue={showOptions[0]}
          placeholder={placeholder}
        />
      )}
    </>
  );
};

export { SelectBreeds };

SelectBreeds.propTypes = {
  onSelect: PropTypes.func,
  startListValue: PropTypes.object,
};
